export default __webpack_public_path__ + "static/media/departamentos.ed50ded3.svg";